module.exports = "\r\n      <app-show-how-it-works currentPageId=\"currentPageId\"></app-show-how-it-works>\r\n\r\n"